import React from 'react'
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {Link} from "react-router-dom";
import {KTIcon} from "../../../../_metronic/helpers";
import {IFaqItem} from "../../../types/faq";
import moment from "moment";
import {MODERATOR_FAQ} from "../../../mock/URLs";

type FaqCardType = {
  faq: IFaqItem,
  refetchFaq: () => void
}

export const FaqCard = ({faq, refetchFaq}: FaqCardType) => {
  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_FAQ, id, refetchFaq);
  };

  return (
      <div className={"mb-5"} key={faq?.id}>
        <div className="card">
          <div className={"p-5 rounded-4 row"}>
            <div className={"col-md-10"}>
              <div>
                <h1 className={"fs-2 text-truncate"}>{faq?.question}</h1>
                <p className={"text-muted text-truncate"}>
                  {faq?.answer}
                </p>
                <p className="text-muted mb-0 fs-7">{moment(faq?.created_at).format("DD.MM.YYYY HH:ss")}</p>
              </div>
            </div>
            <div className={"col-md-2"}>
              <Link to={`/faq/update/${faq?.id}`} className={"btn btn-sm btn-light-primary w-100"}>
                <KTIcon iconName={"pencil"} className={"fs-4"}/>
                Tahrirlash
              </Link>
              <button onClick={() => handleDeleteClick(faq?.id)} className="btn btn-danger btn-sm w-100 mt-2">
                <KTIcon iconName={"trash-square"} className={"fs-3"}/>
                O'chirish
              </button>
            </div>
          </div>
        </div>
      </div>
  )
}
